"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MtaDeclineTextOnLimitExceededWidget = void 0;
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var react_router_dom_1 = require("react-router-dom");
var React = require("react");
var MtaDeclineTextOnLimitExceededWidget = /** @class */ (function (_super) {
    __extends(MtaDeclineTextOnLimitExceededWidget, _super);
    function MtaDeclineTextOnLimitExceededWidget(props) {
        return _super.call(this, props) || this;
    }
    MtaDeclineTextOnLimitExceededWidget.prototype.render = function () {
        return (React.createElement("div", { className: "text-group declineTextWidget" },
            React.createElement("div", { className: "dissatisfied-icon" }),
            React.createElement("div", { className: "font-weight-bold" }, "With the changes you are looking to make, we\u2019d no longer be able to insure you due to the change in risk."),
            React.createElement("br", null),
            React.createElement("div", { className: "font-weight-semi-bold" }, "You can cancel these changes which will allow the policy to continue, or if the cover is no longer suitable for your needs you can cancel the insurance without a cancellation fee."),
            React.createElement("div", null,
                this.renderCancelChangesButton(),
                this.renderCancelPolicyButton())));
    };
    MtaDeclineTextOnLimitExceededWidget.prototype.renderCancelPolicyButton = function () {
        return (React.createElement(react_router_dom_1.Link, { to: "/journey/init/product/AnnualHomeInsurance/process/mtcForced/presetPage/".concat(this.props.interaction._id), id: "cancelPolicy", className: "hard-decline" },
            React.createElement("button", { type: "button", className: "btn btn-primary btn-next decline-cancel hard-decline" }, "Cancel policy")));
    };
    MtaDeclineTextOnLimitExceededWidget.prototype.renderCancelChangesButton = function () {
        return (React.createElement(react_router_dom_1.Link, { to: "/dashboard", id: "decline-page-back" },
            React.createElement("button", { type: "button", className: "btn btn-back" }, "Cancel changes")));
    };
    return MtaDeclineTextOnLimitExceededWidget;
}(plugin_journey_1.WidgetBase));
exports.MtaDeclineTextOnLimitExceededWidget = MtaDeclineTextOnLimitExceededWidget;
//# sourceMappingURL=MtaDeclineTextOnLimitExceededWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/declineTextOutputWidget/MtaDeclineTextOnLimitExceededWidget.js
// module id = 3671
// module chunks = 0